import { OccupancyStore } from '@yard/stores/OccupancyStore'
import { AllocationRuleStore } from '@yard/stores/allocation-rule.store'
import { YardBlockStore } from '@yard/stores/YardBlockStore'
import { observer } from 'mobx-react-lite'
import { BerthViewStore } from '../../stores/nodes/berth.view-store'
import { FlexibleBlockViewStore } from '../../stores/nodes/flexible-block.view-store'
import { HousekeepingPlanAccumulatorViewStore } from '../../stores/housekeeping-plan-accumulator.view-store'
import { LayoutObjectViewStore } from '../../stores/nodes/layout-object.view-store'
import { RailTrackViewStore } from '../../stores/nodes/rail-track.view-store'
import { YardBlockViewStore } from '../../stores/nodes/yard-block.view-store'
import { BerthDialogs } from './BerthDialogs'
import { FlexibleBlockDialogs } from './FlexibleBlockDialogs'
import { CreateHousekeepingPlanDialog } from './HousekeepingPlan/CreateHousekeepingPlanDialog'
import { LayoutObjectDialogs } from './LayoutObjectDialogs'
import { RailTrackDialogs } from './RailTrackDialogs'
import { YardBlockDialogs } from './YardBlockDialogs'

interface Props {
  yardBlockViewStore: YardBlockViewStore
  flexibleBlockViewStore: FlexibleBlockViewStore
  layoutObjectViewStore: LayoutObjectViewStore
  berthViewStore: BerthViewStore
  railTrackViewStore: RailTrackViewStore
  allocationRuleStore: AllocationRuleStore
  housekeepingPlanAccumulatorViewStore: HousekeepingPlanAccumulatorViewStore
  yardBlockStore: YardBlockStore
  occupancyStore: OccupancyStore
}

export const YardFormDialogs = observer(
  ({
    yardBlockViewStore,
    flexibleBlockViewStore,
    layoutObjectViewStore,
    berthViewStore,
    railTrackViewStore,
    allocationRuleStore,
    housekeepingPlanAccumulatorViewStore,
    yardBlockStore,
    occupancyStore,
  }: Props) => (
    <>
      <YardBlockDialogs
        yardBlockViewStore={yardBlockViewStore}
        allocationRuleStore={allocationRuleStore}
      />
      <FlexibleBlockDialogs
        flexibleBlockViewStore={flexibleBlockViewStore}
        allocationRuleStore={allocationRuleStore}
      />
      <LayoutObjectDialogs layoutObjectViewStore={layoutObjectViewStore} />
      <BerthDialogs berthViewStore={berthViewStore} />
      <RailTrackDialogs railTrackViewStore={railTrackViewStore} />
      <CreateHousekeepingPlanDialog
        housekeepingPlanAccumulatorViewStore={housekeepingPlanAccumulatorViewStore}
        yardBlockStore={yardBlockStore}
        occupancyStore={occupancyStore}
      />
    </>
  ),
)
